import { Record } from "../../fable_modules/fable-library.3.7.20/Types.js";
import { option_type, obj_type, list_type, equals, int32_type, record_type, string_type } from "../../fable_modules/fable-library.3.7.20/Reflection.js";
import { InvoiceeDetails$reflection } from "../Invoicee/Common.js";
import { FunctionComponent_Of_Z5A158BBF } from "../../fable_modules/Fable.React.7.4.3/Fable.React.FunctionComponent.fs.js";
import { useSelector } from "../../Redux/Store.js";
import { SaveStatus, getTranslationFrom } from "../../Global.js";
import * as react from "react";
import { singleton as singleton_2, isEmpty, cons, map, empty } from "../../fable_modules/fable-library.3.7.20/List.js";
import { logi } from "../../Utils.js";
import { printf, toText } from "../../fable_modules/fable-library.3.7.20/String.js";
import { ValidatedUrlModule_value, UrlKind, ValidatedUrlModule_create } from "../../HttpV2.js";
import { startImmediate } from "../../fable_modules/fable-library.3.7.20/Async.js";
import { singleton } from "../../fable_modules/fable-library.3.7.20/AsyncBuilder.js";
import { FSharpResult$2 } from "../../fable_modules/fable-library.3.7.20/Choice.js";
import { some, value as value_6, defaultArg } from "../../fable_modules/fable-library.3.7.20/Option.js";
import { CaseStrategy$reflection, CaseStrategy } from "../../fable_modules/Thoth.Json.10.2.0/Types.fs.js";
import { Auto_generateBoxedDecoder_79988AEF, fromString } from "../../fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { equals as equals_1, uncurry } from "../../fable_modules/fable-library.3.7.20/Util.js";
import { getCsrfEnabledRequest, ValidatedUrlModule_value as ValidatedUrlModule_value_1, addClientReference, Http_get_ExtraCoders } from "../../HttpV2.js";
import { Http_content, Http_request, Http_method, Http_withCredentials, Http_send } from "../../fable_modules/Fable.SimpleHttp.3.0.0/Http.fs.js";
import { BodyContent, HttpMethod } from "../../fable_modules/Fable.SimpleHttp.3.0.0/Types.fs.js";
import { selectOption, SelectOption, ValueProp as ValueProp_1, SelectOption_get_getDefault } from "../../Components/FormFields/FormFields.js";
import { Browser_Types_Event__Event_get_Value } from "../../fable_modules/Fable.React.7.4.3/Fable.React.Extensions.fs.js";
import { singleton as singleton_1, delay, toList } from "../../fable_modules/fable-library.3.7.20/Seq.js";
import { warning } from "../../Components/Message/Message.js";
import { ButtonProps_get_getDefault, ButtonProps, defaultProps, main } from "../../Components/Button/Button.js";
import { Auto_generateBoxedEncoder_Z20B7B430, toString } from "../../fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import { renderAsModalThenSaveState } from "../../Components/Modals/SaveState/SaveState.js";
import { ModalSize } from "../../Components/Modal/Modal.js";
import "../../../src/Containers/Subscriptions/DownloadPDFAndSign.scss";


export class TemplateDTO extends Record {
    constructor(Templatename) {
        super();
        this.Templatename = Templatename;
    }
}

export function TemplateDTO$reflection() {
    return record_type("Containers.Subscriptions.DownloadPDFAndSign.TemplateDTO", [], TemplateDTO, () => [["Templatename", string_type]]);
}

export class DownLoadAndSignProps extends Record {
    constructor(ClientNr, ContractNr, InvoiceeDetails) {
        super();
        this.ClientNr = (ClientNr | 0);
        this.ContractNr = (ContractNr | 0);
        this.InvoiceeDetails = InvoiceeDetails;
    }
}

export function DownLoadAndSignProps$reflection() {
    return record_type("Containers.Subscriptions.DownloadPDFAndSign.DownLoadAndSignProps", [], DownLoadAndSignProps, () => [["ClientNr", int32_type], ["ContractNr", int32_type], ["InvoiceeDetails", InvoiceeDetails$reflection()]]);
}

export const view = FunctionComponent_Of_Z5A158BBF((props) => {
    let children_4, children, children_2, children_10, children_6, children_21, children_15, children_17, children_27, children_23;
    const translationsLoadState = useSelector((state) => state.Model.Translations);
    const getTranslation = (key) => getTranslationFrom(translationsLoadState, key);
    const pdfTemplates = react.useState(empty());
    const selectedTemplate = react.useState(void 0);
    const downloadLink = react.useState(void 0);
    const templatesLoaded = react.useState(false);
    const setSelectedTemplate = (templateOption) => {
        selectedTemplate[1]((_arg) => templateOption);
        if (templateOption != null) {
            const template = templateOption;
            logi(toText(printf("set selected template: %s"))(template));
            downloadLink[1]((_arg_2) => {
                const matchValue = ValidatedUrlModule_create(new UrlKind(0, toText(printf("/Template/%i/%i/%s"))(props.ClientNr)(props.ContractNr)(template)));
                return (matchValue.tag === 1) ? (void 0) : ValidatedUrlModule_value(matchValue.fields[0]);
            });
        }
        else {
            downloadLink[1]((_arg_1) => (void 0));
        }
    };
    react.useEffect(() => {
        let a, matchValue_1, parseFn, arg_6;
        if (!(templatesLoaded[0])) {
            startImmediate((a = ((matchValue_1 = ValidatedUrlModule_create(new UrlKind(0, toText(printf("SYSTEM/template/%i"))(props.ClientNr))), (matchValue_1.tag === 1) ? singleton.Return(new FSharpResult$2(1, matchValue_1.fields[0])) : ((parseFn = ((arg_6 = defaultArg(new CaseStrategy(2), new CaseStrategy(0)), (arg_1_1) => {
                const str = arg_1_1;
                return equals(list_type(TemplateDTO$reflection()), string_type) ? (new FSharpResult$2(0, str)) : fromString(uncurry(2, Auto_generateBoxedDecoder_79988AEF(list_type(TemplateDTO$reflection()), arg_6, Http_get_ExtraCoders().Value)), str);
            })), singleton.Delay(() => singleton.Bind(Http_send(addClientReference(Http_withCredentials(true, Http_method(new HttpMethod(0), Http_request(ValidatedUrlModule_value_1(matchValue_1.fields[0])))))), (_arg_3) => {
                let response_1;
                return singleton.Return((response_1 = _arg_3, (response_1.statusCode === 200) ? (equals(list_type(TemplateDTO$reflection()), string_type) ? (new FSharpResult$2(0, response_1.responseText)) : parseFn(response_1.responseText)) : (new FSharpResult$2(1, response_1.responseText))));
            })))))), singleton.Delay(() => singleton.Bind(a, (_arg_4) => {
                let res;
                return singleton.Return((res = _arg_4, (res.tag === 1) ? (() => {
                    throw (new Error("internal error"));
                })() : (pdfTemplates[1]((x_5) => map((t) => t.Templatename, res.fields[0])))));
            }))));
            templatesLoaded[1]((_arg_5) => true);
        }
    });
    const showModal = react.useState(false);
    const saveStatus = react.useState(new SaveStatus(0));
    const closeModal = () => {
        showModal[1]((_arg_7) => false);
        saveStatus[1]((_arg_8) => (new SaveStatus(0)));
    };
    let options;
    const inputRecord = SelectOption_get_getDefault();
    options = (new SelectOption(new ValueProp_1(0, defaultArg(selectedTemplate[0], ""), (ev) => {
        let arg_15;
        logi((arg_15 = Browser_Types_Event__Event_get_Value(ev), toText(printf("ev.Value: %s"))(arg_15)));
        if ((!equals_1(ev, null)) && (Browser_Types_Event__Event_get_Value(ev) !== "")) {
            setSelectedTemplate(Browser_Types_Event__Event_get_Value(ev));
        }
        else {
            setSelectedTemplate(void 0);
        }
    }), "download-pdf-choose-template", cons(["", getTranslation("Common.Choose")], map((x_11) => [x_11, x_11], pdfTemplates[0])), inputRecord.Classes, getTranslation("ChooseTemplate"), false, inputRecord.HTMLProps));
    let modalBody;
    const children_29 = [(children_4 = [(children = toList(delay(() => (isEmpty(options.OptionValues) ? singleton_1(warning(getTranslation("Components.DownloadPDF.ThereAreNoTemplates").split(""))) : singleton_1(selectOption(options))))), react.createElement("td", {
        rowSpan: 2,
    }, ...children)), (children_2 = [getTranslation("Common.SendTo")], react.createElement("th", {}, ...children_2))], react.createElement("tr", {}, ...children_4)), (children_10 = [(children_6 = [getTranslation("Common.Name")], react.createElement("td", {}, ...children_6)), react.createElement("td", {}, props.InvoiceeDetails.Name)], react.createElement("tr", {}, ...children_10)), (children_21 = [(children_15 = toList(delay(() => {
        let children_12;
        const matchValue_7 = downloadLink[0];
        if (matchValue_7 == null) {
            return singleton_1(react.createElement(react.Fragment, {}));
        }
        else {
            const link = matchValue_7;
            return singleton_1((children_12 = [main(new ButtonProps(getTranslation("Common.ViewDocument"), defaultProps.Content, defaultProps.OnClick, defaultProps.Disabled, defaultProps.Id, defaultProps.SaveStatus, defaultProps.HTMLProps, defaultProps.ExtraClasses, defaultProps.Icon))], react.createElement("a", {
                className: "w-100",
                href: link,
                target: "_blank",
            }, ...children_12)));
        }
    })), react.createElement("td", {
        rowSpan: 2,
    }, ...children_15)), (children_17 = [getTranslation("Common.PersonalNr")], react.createElement("td", {}, ...children_17)), react.createElement("td", {}, props.InvoiceeDetails.OrganizationNr)], react.createElement("tr", {}, ...children_21)), (children_27 = [(children_23 = [getTranslation("Common.PhoneNumber")], react.createElement("td", {}, ...children_23)), react.createElement("td", {}, props.InvoiceeDetails.ContactPhoneNumber)], react.createElement("tr", {}, ...children_27))];
    modalBody = react.createElement("table", {
        className: "modal__table",
    }, ...children_29);
    let cancelButtonProps;
    const inputRecord_1 = ButtonProps_get_getDefault();
    cancelButtonProps = (new ButtonProps(getTranslation("Common.Cancel"), inputRecord_1.Content, (_arg_14) => {
        closeModal();
    }, inputRecord_1.Disabled, inputRecord_1.Id, inputRecord_1.SaveStatus, inputRecord_1.HTMLProps, inputRecord_1.ExtraClasses, inputRecord_1.Icon));
    let acceptButtonProps;
    const inputRecord_2 = ButtonProps_get_getDefault();
    acceptButtonProps = (new ButtonProps(getTranslation("Common.SendForSigning"), inputRecord_2.Content, (_arg_15) => {
        let a_4, matchValue_4, requestCaseStrategy_1, parseFn_2, arg_12, jsonStr;
        let url_3;
        const arg_11 = value_6(selectedTemplate[0]);
        url_3 = toText(printf("SYSTEM/template/%i/%i/%s/sign"))(props.ClientNr)(props.ContractNr)(arg_11);
        saveStatus[1]((_arg_9) => (new SaveStatus(1)));
        startImmediate((a_4 = ((matchValue_4 = ValidatedUrlModule_create(new UrlKind(0, url_3)), (matchValue_4.tag === 1) ? singleton.Return(new FSharpResult$2(1, matchValue_4.fields[0])) : ((requestCaseStrategy_1 = defaultArg(new CaseStrategy(0), new CaseStrategy(0)), (parseFn_2 = ((arg_12 = defaultArg(new CaseStrategy(0), new CaseStrategy(0)), (arg_1_2) => {
            const str_1 = arg_1_2;
            return equals(obj_type, string_type) ? (new FSharpResult$2(0, str_1)) : fromString(uncurry(2, Auto_generateBoxedDecoder_79988AEF(obj_type, arg_12, Http_get_ExtraCoders().Value)), str_1);
        })), (jsonStr = toString(0, Auto_generateBoxedEncoder_Z20B7B430(option_type(option_type(CaseStrategy$reflection())), requestCaseStrategy_1, Http_get_ExtraCoders().Value, false)(some(new CaseStrategy(2)))), singleton.Delay(() => {
            let a_2;
            return singleton.Bind((a_2 = getCsrfEnabledRequest(addClientReference(Http_withCredentials(true, Http_content(new BodyContent(1, jsonStr), Http_method(new HttpMethod(1), Http_request(ValidatedUrlModule_value_1(matchValue_4.fields[0]))))))), singleton.Bind(a_2, Http_send)), (_arg_10) => {
                const response_2 = _arg_10;
                return (response_2.statusCode === 200) ? singleton.Return(parseFn_2(response_2.responseText)) : singleton.Return(new FSharpResult$2(1, response_2.responseText));
            });
        }))))))), singleton.Delay(() => singleton.Bind(a_4, (_arg_13) => {
            let res_1;
            return singleton.Return((res_1 = _arg_13, (res_1.tag === 1) ? (saveStatus[1]((_arg_12) => (new SaveStatus(3, res_1.fields[0])))) : (saveStatus[1]((_arg_11) => (new SaveStatus(2))))));
        }))));
    }, (downloadLink[0]) == null, inputRecord_2.Id, inputRecord_2.SaveStatus, inputRecord_2.HTMLProps, inputRecord_2.ExtraClasses, inputRecord_2.Icon));
    const children_31 = [main(new ButtonProps(getTranslation("Common.SignDocument"), defaultProps.Content, (_arg_16) => {
        showModal[1]((_arg_6) => true);
    }, defaultProps.Disabled, "confirm-btn", defaultProps.SaveStatus, defaultProps.HTMLProps, defaultProps.ExtraClasses, defaultProps.Icon)), renderAsModalThenSaveState(showModal[0], new ModalSize(1), getTranslation("Common.SendDocumentForSigning"), modalBody, cancelButtonProps, acceptButtonProps, getTranslation("Common.Ok"), (_arg_17) => {
        closeModal();
    }, singleton_2([getTranslation("Common.SendForSigning"), saveStatus[0]]))];
    return react.createElement("div", {}, ...children_31);
}, "DownLoadAndSign", uncurry(2, void 0), void 0, "view", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\Subscriptions\\DownloadPDFAndSign.fs", 183);

